const GlobalConfig = {

    install(Vue) {
        Vue.mixin({
            methods: {
                /*
                  Calculate the Age based on date passed (YYYY-MM-DD) to the function
                */
                calculateAge(year, month, day) {
                    var today = new Date()
                    var birthDate = new Date(year, month, day)
                    var age = today.getFullYear() - birthDate.getFullYear()
                    var m = today.getMonth() - birthDate.getMonth()
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--
                    }
                    return age
                }
            },
            data: function () {
                return {
                    get configStrings() {
                        return {
                            clubName: 'Aston Villa',
                            productName: 'Digital Account',
                            AltProductName: 'Villa Account'
                        }
                    },

                    get configValues() {
                        return {
                            accountConsentRequired: true, // true or false
                            accountConsentAge: 13 // numeric value
                        }
                    },

                    /*
                    An array of domains that the site trusts in order to perform redirects
                    */
                    get configTrustedDomains() {
                        return [
                            'astonvillafcpayments.streamamg.com',
                            'avfc.co.uk',
                            'avfc.foundationauction.org',
                            'auction-sprtgavfcfoundlive1.oc1.servicecdi.com'
                        ]
                    }
                }
            }
        })
    }
}
export default GlobalConfig
